import React from "react";
import Errors from '../Errors/Errors'
import CurrencyInput from "../CurrencyInput/CurrencyInput"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export default class AddRemoveCash extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      loading: false,
      amount: this.props.amount || 0,
      notes: this.props.notes || '',
    }

    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  /**
   * Render functions
   */

  render() {
    return (
      <div className="AddRemoveCash">
        <Errors errors={this.state.errors} />
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label>{`${I18n.t('amount')}*`}</label>
              <CurrencyInput name='amount' value={this.state.amount} className="form-control" onChange={this.onChange} onChangeEventType={true} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{`${I18n.t('notes')}*`}</label>
              <textarea className="form-control" rows={5} name="notes" value={this.state.notes} onChange={this.onChange}></textarea>
            </div>
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={this.renderButtons()} />
      </div>
    )
  }

  renderButtons() {
    return [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
      {
        name: I18n.t('remove_cash'),
        button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons'],
        onClick: (e) => {
          this.onSave('remove');
        }
      },
      {
        name: I18n.t('add_cash'),
        button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons'],
        onClick: (e) => {
          this.onSave('add');
        }
      },
    ];
  }

  /**
   * Change handlers
   */

   onChange(event) {
    var state = {...this.state}
    state[event.target.name] = event.target.value
    this.setState(state)
  }

  /**
   * Helper functions
   */

  onSave(add_or_remove) {
    this.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: this.props.save_path,
      data: {
        cash_drawer_id: this.props.cash_drawer_id,
        amount: (add_or_remove === 'remove' ? -1 : 1) * Math.abs(this.state.amount),
        notes: this.state.notes,
      },
    }).done((data) => {
      if (data.success) {
        this.setState({loading: false})
        parent.refresh_data()
        parent.hide_modal()
      } else if (data.errors) {
        this.setState({
          loading: false,
          errors: data.errors,
        });
      };
    });
  }

}
